import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <CarouselSection />
        <AppSection />
        <UpdatesSection />
        <CardsSection />
        <AboutSection />
        <CommentsSection />
        <MediaSection />
        <ContactSection />
        <FeaturesSection />
        <FaqSection />
        <IndexSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}